import timezones from "timezones-list";

type TimeZoneOption = {
  label: string;
  value: string;
};

const getTimeZoneOptions = (): TimeZoneOption[] => {
  const options = timezones.map(({ tzCode: value, name: label }) => ({ value, label }));

  return options;
};

export default getTimeZoneOptions;
